// @flow
import {
  GET_GENERAL_POLICY_SUCCESS,
  UPDATE_CLAIM_STATUS_SUCCESS,
  UPDATE_CLAIM_STATUS_FAILED,
  GET_WAREHOUSE_RECORDS_SUCCESS,
  GET_WAREHOUSE_RECORDS_FAILED,
  TOGGLE_INVENTORY_ITEM_MODAL,
  UPLOAD_IMAGE_SUCCESS,
  UPDATE_INVENTORY_ITEM,
  CREATE_INVENTORY_ITEM_SUCCESS,
  CREATE_INVENTORY_ITEM_FAILED,
  DELETE_INVENTORY_ITEM_SUCCESS,
  DELETE_INVENTORY_ITEM_FAILED,
} from '../constants'
import type { Policy, WarehouseRecord, InventoryItem } from '../types'

const initialState = {
  currentPolicy: null,
  success: "",
  error: "",
  warehouseRecords: [],
  openInventoryItemModal: false,
  newInventoryItem: {
    policyId: '',
    coverageId: '',
    claimId: '',
    quantity: '',
    inventoryItemId: '',
    images: [],
    notes: '',
    isDamaged: false,
  }
}

type State = {
  currentPolicy: ?Policy,
  success: string,
  error: string,
  warehouseRecords: Array<WarehouseRecord>,
  openInventoryItemModal: bool,
  newInventoryItem: InventoryItem,
}


type Action = {
  type: string,
  payload: any,
}

function generalReturnDetails(state: State = initialState, action: Action) {
  switch (action.type) {
    case GET_GENERAL_POLICY_SUCCESS:
      return {
        ...state,
        currentPolicy: action.payload
      }
    case UPDATE_CLAIM_STATUS_SUCCESS:
      return {
        ...state,
        success: action.payload
      }
    case UPDATE_CLAIM_STATUS_FAILED:
      return {
        ...state,
        error: action.payload
      }
    case GET_WAREHOUSE_RECORDS_SUCCESS:
      return {
        ...state,
        warehouseRecords: action.payload
      }
    case GET_WAREHOUSE_RECORDS_FAILED:
      return {
        ...state,
        error: action.payload
      }
    case TOGGLE_INVENTORY_ITEM_MODAL:
      return {
        ...state,
        openInventoryItemModal: action.payload.open,
        newInventoryItem: action.payload.open ? action.payload.data : {
          policyId: '',
          coverageId: '',
          claimId: '',
          quantity: '',
          inventoryItemId: '',
          images: [],
          notes: '',
          isDamaged: false,
        }
      }
    case UPDATE_INVENTORY_ITEM:
      return {
        ...state,
        newInventoryItem: action.payload
      }
    case UPLOAD_IMAGE_SUCCESS:
      return {
        ...state,
        newInventoryItem: {
          ...state.newInventoryItem,
          images: state.newInventoryItem.images.concat(action.payload)
        }
      }
    case CREATE_INVENTORY_ITEM_SUCCESS:
      return {
        ...state,
        success: action.payload
      }
    case CREATE_INVENTORY_ITEM_FAILED:
      return {
        ...state,
        error: action.payload
      }
    case DELETE_INVENTORY_ITEM_SUCCESS:
      return {
        ...state,
        success: action.payload
      }
    case DELETE_INVENTORY_ITEM_FAILED:
      return {
        ...state,
        error: action.payload
      }
    default:
      return state
  }
}

export default generalReturnDetails



// WEBPACK FOOTER //
// ./src/modules/generalReturnDetails.js